<template>
  <div class="nav-right-with-contact" id="header" :class="darkClass" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div
      class="contact-toolbar-dark-component toolbar-sticky sticky-nav-element"
    >
      <div class="container">
        <div class="row">
          <div v-if="brand.toLowerCase() != 'mazda'" class="vcenter toolbar-select-language">
            <a aria-label="Select Language" class="event-click track-click translate-link" data-action="Select Language" data-category="Nav Utility Bar" href="#select-lang">
              <i aria-hidden="true" class="fa fa-globe"></i>
              <span>&nbsp;&nbsp;Select Language&nbsp;</span>
              <i aria-hidden="true" class="fa fa-caret-down"></i>
            </a>
          </div>
          <div v-if="brand.toLowerCase() != 'mazda'" class="vcenter toolbar-hours">
            <a aria-label="hours" class="event-click track-click hours-link" data-action="Hours Click" data-category="Hours &amp;amp; Directions" data-label="Dealership Hours Link" href="/hours">
              <i aria-hidden="true" class="fa fa-clock-o"></i>
              <span>&nbsp;&nbsp;<span class="nav-hour nav-hour--sales"><span class="category-delimiter"></span><span class="category-name">Sales: </span><span class="hour hour-open">8:30</span><span class="field-delimiter"> - </span><span class="hour hour-close">6</span></span><span class="nav-hour nav-hour--service"><span class="category-delimiter"> • </span><span class="category-name">Service: </span><span class="hour hour-open">8</span><span class="field-delimiter"> - </span><span class="hour hour-close">3</span></span></span>
            </a>
          </div>
          <div class="col-lg-3 vcenter hidden-md toolbar-address">
            <div class="address">
              <a
                alt="11550 Common Oaks Dr, Raleigh, NC 27614"
                aria-label="address"
                class="track-click"
                data-action="Address Click"
                data-category="Hours &amp;amp; Directions"
                data-label="Dealership Address Link"
                href="#"
                >11550 Common
                Oaks Dr, Raleigh, NC 27614</a
              >
            </div>
          </div>
          <div class="col-lg-6 vcenter toolbar-phone-numbers">
            <div class="text-center">
              <a aria-label="sales number" class="sales phone-link ws-dynamic-number" data-number-type="sales" href="#">
                <span class="phone-label">Sales / Service / Parts:&nbsp;</span><span class="phone-number">(919) XXX-XXXX</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="toolbar_shadow"></div>
    </div>
    <div class="hidden-sm hidden-xs">
      <div class="nav-height"></div>
      <div class="navbar navbar-inverse" role="navigation">
        <header data-collapsible="false" id="desktop-header">
          <div class="container">
            <div class="header-wrapper clearfix">
              <div id="desktop-logo">
                <a href="#"
                  ><img
                    alt="Dealer Name Here"
                    class="dealer-logo"
                    :src="[!logoURL ? logoSRC : logoURL]"
                    title="Dealer Name Here"
                /></a>
              </div>
              <a class="skip-navigation" href="#skip-to-main"
                >SKIP NAVIGATION</a
              >
              <ul
                class="navbar-nav"
                data-more-dropdown="false"
                id="desktop-menu"
                role="menubar"
              >
                <li class="dropdown models-dropdown collapse" role="none" @mouseenter="addOpen" @mouseleave="removeOpen">
                  <a
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown="true"
                    data-section-title="New"
                    data-toggle="dropdown"
                    href="#"
                    role="menuitem"
                    target=""
                    >New</a
                  >
                  <ul
                    aria-label="New"
                    class="dropdown-menu models-dropdown-menu"
                    role="menu"
                  >
                    <div
                      class="vehicle-model-dropdown"
                      data-section-title="New"
                    >
                      <div class="dropdown-wrapper">
                        <div class="container">
                          <div class="row">
                            <div class="col-sm-12 model-column">
                              <div class="models-wrapper">
                                <div class="model-container" v-for="suv in images.suvs" :key="suv.modelName">
                                  <a href="#"
                                    ><div class="model-text">
                                      <h3 role="presentation">{{suv.modelName}}</h3>
                                      <span class="vehicles-count">19 available</span>
                                    </div>
                                    <img
                                      :alt="suv.modelName"
                                      :src="suv.sideView"
                                  /></a>
                                </div>
                                <div class="model-container" v-for="truck in images.trucks" :key="truck.modelName">
                                  <a href="#"
                                    ><div class="model-text">
                                      <h3 role="presentation">{{truck.modelName}}</h3>
                                      <span class="vehicles-count">19 available</span>
                                    </div>
                                    <img
                                      :alt="truck.modelName"
                                      :src="truck.sideView"
                                  /></a>
                                </div>
                                <div class="model-container" v-for="sedan in images.sedans" :key="sedan.modelName">
                                  <a href="#"
                                    ><div class="model-text">
                                      <h3 role="presentation">{{sedan.modelName}}</h3>
                                      <span class="vehicles-count">19 available</span>
                                    </div>
                                    <img
                                      :alt="sedan.modelName"
                                      :src="sedan.sideView"
                                  /></a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="search-btns">
                        <a class="btn" href="#">
                          View New Inventory</a
                        ><a class="btn" href="#"
                          >Schedule Test Drive</a
                        >
                      </div>
                    </div>
                  </ul>
                </li>
                <li
                  class="dropdown models-dropdown-sibling"
                  role="none" 
                  style="display: none;" 
                  @mouseenter="addOpen" 
                  @mouseleave="removeOpen"
                >
                  <a
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown="true"
                    data-section-title="New"
                    data-toggle="dropdown"
                    href="#"
                    role="menuitem"
                    target=""
                    >New</a
                  >
                  <ul aria-label="New" class="dropdown-menu" role="menu">
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Browse Inventory</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Schedule A Test Drive</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Value Your Trade</a
                      >
                    </li>
                  </ul>
                </li>
                <li 
                  class="dropdown" 
                  role="none" 
                  @mouseenter="addOpen" 
                  @mouseleave="removeOpen"
                >
                  <a
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown=""
                    data-section-title="Pre-Owned"
                    data-toggle="dropdown"
                    href="#"
                    role="menuitem"
                    target=""
                    >Pre-Owned</a
                  >
                  <ul aria-label="Pre-Owned" class="dropdown-menu" role="menu">
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Browse Inventory</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Schedule A Test Drive</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Value Your Trade</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Vehicles Under $12,000</a
                      >
                    </li>
                  </ul>
                </li>
                <li 
                  class="dropdown" 
                  role="none" 
                  @mouseenter="addOpen" 
                  @mouseleave="removeOpen"
                >
                  <a
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown=""
                    data-section-title="Certified Pre-Owned"
                    data-toggle="dropdown"
                    href="#"
                    role="menuitem"
                    target=""
                    >Certified Pre-Owned</a
                  >
                  <ul
                    aria-label="Certified Pre-Owned"
                    class="dropdown-menu"
                    role="menu"
                  >
                    <li role="none">
                      <a
                        href="#"
                        role="menuitem"
                        target=""
                        >Certified Pre-Owned</a
                      >
                    </li>
                    <li role="none">
                      <a
                        href="#"
                        role="menuitem"
                        target=""
                        >Why Buy Our Certified Pre-Owned</a
                      >
                    </li>
                  </ul>
                </li>
                <li 
                  class="dropdown" 
                  role="none" 
                  @mouseenter="addOpen" 
                  @mouseleave="removeOpen"
                >
                  <a
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown=""
                    data-section-title="Shopping Tools"
                    data-toggle="dropdown"
                    href="#"
                    role="menuitem"
                    target=""
                    >Shopping Tools</a
                  >
                  <ul
                    aria-label="Shopping Tools"
                    class="dropdown-menu"
                    role="menu"
                  >
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Get Pre-Approved</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Search By Payment</a
                      >
                    </li>
                    <li role="none">
                      <a
                        href="#"
                        role="menuitem"
                        target=""
                        >Reserve Your New Vehicle</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Model Research</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >New Vehicle Specials</a
                      >
                    </li>
                    <li role="none">
                      <a
                        href="#"
                        role="menuitem"
                        target=""
                        >Pre-Owned Specials</a
                      >
                    </li>
                  </ul>
                </li>
                <li 
                  class="dropdown" 
                  role="none" 
                  @mouseenter="addOpen" 
                  @mouseleave="removeOpen"
                >
                  <a
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown=""
                    data-section-title="Service"
                    data-toggle="dropdown"
                    href="#"
                    role="menuitem"
                    target=""
                    >Service</a
                  >
                  <ul aria-label="Service" class="dropdown-menu" role="menu">
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Schedule Service Appointment</a
                      >
                    </li>
                    <li role="none">
                      <a
                        href="#"
                        role="menuitem"
                        target=""
                        >Service &amp; Parts Specials</a
                      >
                    </li>
                    <li role="none">
                      <a
                        href="#"
                        role="menuitem"
                        target=""
                        >Parts Request</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Recall Center</a
                      >
                    </li>
                  </ul>
                </li>
                <li 
                  class="dropdown" 
                  role="none" 
                  @mouseenter="addOpen" 
                  @mouseleave="removeOpen"
                >
                  <a
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown=""
                    data-section-title="Finance"
                    data-toggle="dropdown"
                    href="#"
                    role="menuitem"
                    target=""
                    >Finance</a
                  >
                  <ul aria-label="Finance" class="dropdown-menu" role="menu">
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Finance Application</a
                      >
                    </li>
                    <li role="none">
                      <a
                        href="#"
                        role="menuitem"
                        target=""
                        >Value Your Trade</a
                      >
                    </li>
                  </ul>
                </li>
                <li 
                  class="dropdown" 
                  role="none" 
                  @mouseenter="addOpen" 
                  @mouseleave="removeOpen"
                >
                  <a
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown=""
                    data-section-title="About"
                    data-toggle="dropdown"
                    href="#"
                    role="menuitem"
                    target=""
                    >About</a
                  >
                  <ul aria-label="About" class="dropdown-menu" role="menu">
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Contact Us</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Hours &amp; Directions</a
                      >
                    </li>
                    <li role="none">
                      <a
                        href="#"
                        role="menuitem"
                        target="_self"
                        >Career Opportunities</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Staff Directory</a
                      >
                    </li>
                    <li role="none">
                      <a href="#" role="menuitem" target=""
                        >Leave us a Review</a
                      >
                    </li>
                  </ul>
                </li>
                <li>
                  <a 
                    aria-label="search" 
                    href="#dropdown-search"
                    class="dropdown-toggle"
                    data-hover="dropdown"
                    data-model-dropdown=""
                    data-toggle="dropdown"
                    role="menuitem"
                  ></a>
                  <div class="" id="dropdown-search">
                    <div class="container">
                      <div class="search-bar">
                          <div class="input-group">
                            <input
                              aria-label="Search Bar"
                              autocomplete="off"
                              autocorrect="off"
                              class="form-control input-search"
                              data-custom="false"
                              data-placement="bottom"
                              data-search-suggestions="true"
                              data-suggest="true"
                              data-top="Search this site..."
                              name="query"
                              placeholder="Search this site..."
                              spellcheck="false"
                              title="Search this site..."
                              type="text"
                              value=""
                            /><span class="input-group-btn"
                              ><button
                                aria-label="search text"
                                class="btn btn-default no-border-left"
                                type="submit"
                              >
                                <i aria-hidden="true" class="fa fa-search"></i>
                              </button>
                            </span>
                          </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </header>
      </div>
    </div>
    <div class="visible-sm visible-xs">
      <div class="mobile-contact-bar navbar">
        <div class="toggle-side-menu">
          <a class="mobile-menu-toggle" @click="toggleSideNav"
            ><span class="icon-label">MENU</span><span class="icon-bar"></span
            ><span class="icon-bar"></span><span class="icon-bar"></span
          ></a>
        </div>
        <div class="mobile-dealer-logo pull-left">
          <a href="#"
            ><img
              alt="Dealer Name Here"
              class="dealer-logo"
              :src="[!logoURL ? logoSRC : logoURL]"
              title="Dealer Name Here"
          /></a>
        </div>
        <div class="contact-info">
          <div
            class="contact-item mobile-sales-phone"
            id="toggle-click-to-call"
          >
            <i class="fa fa-phone"></i
            ><a
              class="hidden-xs track-click"
              data-action="Sales"
              data-category="Click to Call"
              href="#"
              > (919) XXX-XXXX</a
            >
          </div>
          <a
            class="contact-item mobile-get-directions"
            data-action="Address Click"
            data-category="Hours &amp; Directions"
            data-label="Dealership Address Link"
            href="#"
            itemprop="hasMap"
            ><i aria-hidden="true" class="fa fa-map-marker"></i
            ><span class="hidden-xs"> Directions</span
            ><span class="visuallyhidden">Get Directions</span></a
          >
        </div>
      </div>
    </div>
      <div
        class="mobile-nav-bar sidr left"
        id="sidr"
        role="navigation"
        style="transition: left 0.2s ease 0s" 
        v-if="sideNavOpen"
      >
        <div class="navbar-inner nav navbar-nav">
          <ul class="side-nav" role="menu">
            <div class="search-bar">
                <div class="input-group">
                  <input
                    aria-label="Search Bar"
                    autocomplete="off"
                    autocorrect="off"
                    class="form-control input-search"
                    data-custom="false"
                    data-placement="bottom"
                    data-search-suggestions="true"
                    data-suggest="true"
                    data-top="2022 Mazda3 Sedan"
                    name="query"
                    placeholder="Hours"
                    spellcheck="false"
                    title="Search this site..."
                    type="text"
                    value=""
                  /><span class="input-group-btn"
                    ><button
                      aria-label="search text"
                      class="btn btn-default no-border-left"
                      type="submit"
                    >
                      <i aria-hidden="true" class="fa fa-search"></i></button
                    ><span
                      aria-label="pause automatic search suggest"
                      aria-pressed="false"
                      class="btn btn-default toggleSearchText visuallyhidden"
                      role="button"
                      tabindex="0"
                      ><i aria-hidden="true" class="fa fa-pause"></i></span
                  ></span>
                </div>
            </div>
            <li class="dropdown models-dropdown collapse" role="none" style="display: none;">
              <a
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle"
                data-hover="dropdown"
                data-model-dropdown="true"
                data-section-title="New"
                data-toggle="dropdown"
                href="#"
                role="menuitem"
                target=""
                >New</a
              >
              <ul
                aria-label="New"
                class="dropdown-menu models-dropdown-menu"
                role="menu"
              >
                <div class="vehicle-model-dropdown" data-section-title="New">
                  <div class="dropdown-wrapper">
                    <div class="container">
                      <div class="row">
                        <div class="col-sm-12 model-column">
                          <div class="models-wrapper">
                            <div class="model-container" v-for="suv in images.suvs" :key="suv.modelName">
                              <a href="#"
                                ><div class="model-text">
                                  <h3 role="presentation">{{suv.modelName}}</h3>
                                  <span class="vehicles-count">19 available</span>
                                </div>
                                <img
                                  :alt="suv.modelName"
                                  :src="suv.sideView"
                              /></a>
                            </div>
                            <div class="model-container" v-for="truck in images.trucks" :key="truck.modelName">
                              <a href="#"
                                ><div class="model-text">
                                  <h3 role="presentation">{{truck.modelName}}</h3>
                                  <span class="vehicles-count">19 available</span>
                                </div>
                                <img
                                  :alt="truck.modelName"
                                  :src="truck.sideView"
                              /></a>
                            </div>
                            <div class="model-container" v-for="sedan in images.sedans" :key="sedan.modelName">
                              <a href="#"
                                ><div class="model-text">
                                  <h3 role="presentation">{{sedan.modelName}}</h3>
                                  <span class="vehicles-count">19 available</span>
                                </div>
                                <img
                                  :alt="sedan.modelName"
                                  :src="sedan.sideView"
                              /></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="search-btns">
                    <a class="btn" href="#"> View New Inventory</a
                    ><a class="btn" href="#">Schedule Test Drive</a>
                  </div>
                </div>
              </ul>
            </li>
            <li
              class="dropdown models-dropdown-sibling"
              role="none"
            >
              <a
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle"
                data-hover="dropdown"
                data-model-dropdown="true"
                data-section-title="New"
                data-toggle="dropdown"
                href="#"
                role="menuitem"
                target=""
                >New</a
              >
              <ul aria-label="New" class="dropdown-menu" role="menu">
                <li role="none">
                  <a href="#newvehicles" role="menuitem" target=""
                    >Browse Inventory</a
                  >
                </li>
                <li role="none">
                  <a href="#testdrive" role="menuitem" target=""
                    >Schedule A Test Drive</a
                  >
                </li>
                <li role="none">
                  <a href="#value-your-trade" role="menuitem" target=""
                    >Value Your Trade</a
                  >
                </li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle"
                data-hover="dropdown"
                data-model-dropdown=""
                data-section-title="Pre-Owned"
                data-toggle="dropdown"
                href="#"
                role="menuitem"
                target=""
                >Pre-Owned</a
              >
              <ul aria-label="Pre-Owned" class="dropdown-menu" role="menu">
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Browse Inventory</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Schedule A Test Drive</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Value Your Trade</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Vehicles Under $12,000</a
                  >
                </li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle"
                data-hover="dropdown"
                data-model-dropdown=""
                data-section-title="Certified Pre-Owned"
                data-toggle="dropdown"
                href="#"
                role="menuitem"
                target=""
                >Certified Pre-Owned</a
              >
              <ul
                aria-label="Certified Pre-Owned"
                class="dropdown-menu"
                role="menu"
              >
                <li role="none">
                  <a
                    href="#"
                    role="menuitem"
                    target=""
                    >Certified Pre-Owned</a
                  >
                </li>
                <li role="none">
                  <a
                    href="#"
                    role="menuitem"
                    target=""
                    >Why Buy Our Certified Pre-Owned</a
                  >
                </li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle"
                data-hover="dropdown"
                data-model-dropdown=""
                data-section-title="Shopping Tools"
                data-toggle="dropdown"
                href="#"
                role="menuitem"
                target=""
                >Shopping Tools</a
              >
              <ul aria-label="Shopping Tools" class="dropdown-menu" role="menu">
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Get Pre-Approved</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Search By Payment</a
                  >
                </li>
                <li role="none">
                  <a
                    href="#"
                    role="menuitem"
                    target=""
                    >Reserve Your New Vehicle</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Model Research</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >New Vehicle Specials</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Pre-Owned Specials</a
                  >
                </li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle"
                data-hover="dropdown"
                data-model-dropdown=""
                data-section-title="Service"
                data-toggle="dropdown"
                href="#"
                role="menuitem"
                target=""
                >Service</a
              >
              <ul aria-label="Service" class="dropdown-menu" role="menu">
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Schedule Service Appointment</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Service &amp; Parts Specials</a
                  >
                </li>
                <li role="none">
                  <a
                    href="#"
                    role="menuitem"
                    target=""
                    >Parts Request</a
                  >
                </li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle"
                data-hover="dropdown"
                data-model-dropdown=""
                data-section-title="Service"
                data-toggle="dropdown"
                href="#"
                role="menuitem"
                target=""
                >Finance</a
              >
              <ul aria-label="Service" class="dropdown-menu" role="menu">
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Finance Application</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Value Your Trade</a
                  >
                </li>
              </ul>
            </li>
            <li class="dropdown" role="none">
              <a
                aria-expanded="false"
                aria-haspopup="true"
                class="dropdown-toggle"
                data-hover="dropdown"
                data-model-dropdown=""
                data-section-title="About"
                data-toggle="dropdown"
                href="#"
                role="menuitem"
                target=""
                >About</a
              >
              <ul aria-label="About" class="dropdown-menu" role="menu">
                <li role="none">
                  <a href="#" role="menuitem" target="">Contact Us</a>
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Hours &amp; Directions</a
                  >
                </li>
                <li role="none">
                  <a
                    href="#"
                    role="menuitem"
                    target="_self"
                    >Career Opportunities</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Staff Directory</a
                  >
                </li>
                <li role="none">
                  <a href="#" role="menuitem" target=""
                    >Leave us a Review</a
                  >
                </li>
              </ul>
            </li>
            <div class="close-mobile-wrap" @click="closeSideNav">
              <span class="close-mobile-nav"
                ><i class="fa fa-close">&nbsp;</i><span>close</span></span
              >
            </div>
          </ul>
        </div>
      </div>
  </div>
</template>

<script>
  import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";
</script>

<script>
import originalMobileNavMixin from "../mixins/originalMobileNavMixin";

  export default {
    mixins: [originalMobileNavMixin],
    props: ['images', 'logoURL'],
    data() {
      return {
        brand: this.$store.state.chosenBrand
      };
    },
    computed: {
      darkClass () {
        if (this.brand === "mazda" || this.brand === "kia") {
          return "nav-right-dark";
        }
      },
      logoSRC () {
        if (this.brand === "mazda") {
          return require("../../static/images/common-icons/brand-logos/mazda-more-padding.png");
        } else {
          return this.images.logoExample[0];
        }
      }
    },
  };
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<!-- Application styles -->

<style scoped>
  .skip-navigation {
    position: absolute;
    top: -500px;
    z-index: -1;
    padding: 7px 8px 7px 8px;
    background-color: #fff;
    border: 1px solid #555;
    color: #555;
  }
  .visuallyhidden {
    position: absolute !important;
    overflow: hidden !important;
    clip: rect(0 0 0 0) !important;
    height: 1px !important;
    width: 1px !important;
    margin: -1px !important;
    padding: 0 !important;
    border: 0 !important;
  }
  a[href="#dropdown-search"] {
    font-family: "FontAwesome";
  }
  a[href="#dropdown-search"]::before {
    content: "\F002";
  }
  a[href="#dropdown-search"][aria-expanded="true"]::before {
    content: "";
  }
  #header #dropdown-search {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    padding: 20px 0;
    background-color: #f5f5f5;
  }
  #header #dropdown-search:not(.open) {
      display: none;
  }  
</style>

<!-- Nav Right Expand Search default styles -->

<style scoped>

  .nav-right-with-contact .mobile-dealer-logo.pull-left {
    display: flex;
    max-width: 230px;
    justify-content: space-between;
    align-items: center;
    margin-top: 7px;
  }
  .nav-right-with-contact .dealer-logo {
    max-width: 300px;
    max-height: 70px;
  }
  .nav-right-with-contact .navbar {
    margin-bottom: 0;
    border-radius: 0;
  }
  .nav-right-with-contact header {
    background-color: #fff;
    font-size: 15px;
    font-weight: 400;
    -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
      0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14),
      0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .nav-right-with-contact header > .container {
    position: static;
  }
  .nav-right-with-contact header .container .header-wrapper {
    white-space: nowrap;
  }
  .nav-right-with-contact header .container .header-wrapper #desktop-logo {
    display: inline-block;
    padding-right: 30px;
    vertical-align: middle;
  }
  .nav-right-with-contact header .container .header-wrapper ul {
    margin: 0;
    border: none;
    border-radius: 0;
    padding: 0;
  }
  .nav-right-with-contact header .container .header-wrapper #desktop-menu {
    display: inline-block;
    float: none;
    vertical-align: middle;
  }
  .nav-right-with-contact header .container .header-wrapper #desktop-menu > li {
    display: inline-block;
    vertical-align: top;
    background: transparent;
  }
  .nav-right-with-contact header .container .header-wrapper #desktop-menu > li > a {
    display: block;
    padding: 10px 12px;
    line-height: 28px;
    text-decoration: none;
    font-weight: 500;
    color: var(--primary-dark);
    cursor: pointer;
  }
  .nav-right-with-contact header .container .header-wrapper #desktop-menu > li > a:hover,
  .nav-right-with-contact header .container .header-wrapper #desktop-menu > .open > a {
    color: var(--primary-dark);
    background: transparent;
  }
  .nav-right-with-contact header .navbar-nav > li .dropdown-menu > li a {
    padding: 6px 15px;
  }
  #dropdown-search {
    background-color: var(--secondary-light);
    width: 100%;
  }
  #dropdown-search .search-bar .input-search,
  #dropdown-search .search-bar button {
    height: 40px;
    font-size: 16px;
  }
  .nav-right-with-contact header .container .header-wrapper #desktop-menu .search-bar {
    padding-top: 0;
  }
  .mobile-contact-bar {
    height: 70px;
    background: #fff;
    left: 0;
    top: 0;
    width: 100%;
  }
  .mobile-contact-bar .mobile-dealer-logo img {
    padding: 10px;
  }
  .mobile-contact-bar .mobile-menu-toggle {
    width: 60px;
    height: 70px;
    padding: 25px 15px;
    float: left;
    background: transparent;
  }
  .mobile-contact-bar .mobile-menu-toggle .icon-bar {
    display: block;
    margin-top: 4px;
    width: 30px;
    height: 3px;
    border-radius: 1px;
    background-color: var(--primary-color);
  }
  .mobile-contact-bar .mobile-menu-toggle .icon-label {
    display: none;
  }
  .mobile-contact-bar .contact-info {
    float: right;
    margin-top: 1.6em;
    margin-right: 1.2em;
  }
  .mobile-contact-bar .contact-info .contact-item {
    display: inline-block;
    vertical-align: middle;
    color: var(--primary-color);
    font-size: 1.7em;
    letter-spacing: 0.05em;
    margin-right: 0.7em;
    font-weight: 600;
  }
  .mobile-contact-bar .contact-info .contact-item:hover {
    text-decoration: none;
    cursor: pointer;
  }
  .mobile-contact-bar .contact-info .contact-item .fa {
    margin-right: 0.1em;
  }
  .mobile-contact-bar .contact-info .contact-item a {
    color: inherit;
  }
  .mobile-contact-bar .contact-info .contact-item a:hover {
    text-decoration: inherit;
  }
  .mobile-nav-bar .side-nav {
    border-bottom: none;
  }
  .mobile-nav-bar .search-bar {
    border: 1px solid #4d4d4d;
  }
  .mobile-nav-bar .search-bar form {
    margin: 0;
  }
  .mobile-nav-bar .search-bar .input-search {
    margin: 0;
    padding: 5;
    height: 40px;
  }
  .mobile-nav-bar .search-bar .input-group-btn {
    padding: 0;
  }
  .mobile-nav-bar .search-bar .input-group-btn button {
    height: 40px;
  }
  .mobile-nav-bar .side-nav > li {
    display: block;
    float: left;
    width: 100%;
    border-bottom: 1px solid #333;
  }
  .mobile-nav-bar .side-nav > li > a,
  .mobile-nav-bar .navbar-inner > ul > li.dropdown.open > a {
    background: #222;
    color: #fff;
    display: block;
    height: 40px;
    font-size: 14px;
    line-height: 20px;
    padding: 10px 15px;
    color: #fff;
    white-space: nowrap;
    font-size: 14px;
    font-weight: normal;
    text-align: left;
    text-transform: none;
    margin: 0;
  }
  .mobile-nav-bar .side-nav > li > a:hover,
  .mobile-nav-bar .navbar-inner > ul > li.dropdown.open > a:hover {
    background: #1c1c1c;
  }
  .mobile-nav-bar .side-nav > li > ul.dropdown-menu > li > a {
    height: 40px;
    line-height: 40px;
    background: #444;
    font-size: 14px;
    color: #fff;
    text-align: left;
    float: left;
    min-width: 100%;
    position: relative;
    border-bottom: 1px solid #333;
  }
  .mobile-nav-bar .side-nav > li > ul.dropdown-menu > li > a:hover {
    background: #333;
  }
  .mobile-nav-bar .close-mobile-wrap {
    text-align: right;
    padding: 10px 15px;
  }
  .mobile-nav-bar .close-mobile-wrap .close-mobile-nav {
    color: #aaa;
  }
  .mobile-nav-bar .close-mobile-wrap .close-mobile-nav:hover {
    cursor: pointer;
    color: #fff;
  }

  @media (min-width: 1501px) {
    .nav-right-with-contact header > .container {
      width: 85%;
      min-width: 1170px;
    }
    .nav-right-with-contact .header-wrapper {
      margin: auto;
      width: fit-content;
    }
  }

  @media (max-width: 1500px) {
    .nav-right-with-contact header > .container {
      width: 100% !important;
    }
  }

  @media (min-width: 1201px) {
    .nav-right-with-contact .navigation_with_contact {
      box-shadow: none;
    }
    .nav-right-with-contact header > .container {
      max-width: 1185px;
    }
  }

  @media (max-width: 1200px) and (min-width: 768px) {
    .nav-right-with-contact .nav-height {
      height: 70px;
    }
    .nav-right-with-contact .hidden-sm {
      display: none !important;
    }
    .nav-right-with-contact .visible-sm {
      display: block !important;
    }
    .nav-right-with-contact .mobile-dealer-logo .dealer-logo {
      max-height: 70px;
    }
  }

  @media (max-width: 767px) {
    .nav-right-with-contact .sub-navigation-vehicle-search .search-form .search-form-option {
      max-width: 80px;
    }
    .nav-right-with-contact .mobile-dealer-logo .dealer-logo {
      max-height: 55px;
    }
    .nav-right-with-contact .mobile-contact-bar {
      height: 55px;
    }
    .nav-right-with-contact .mobile-contact-bar .mobile-menu-toggle {
      height: 55px;
      padding: 15px;
      cursor: pointer;
    }
    .nav-right-with-contact .mobile-contact-bar .contact-info {
      margin-top: 0.8em;
      margin-right: 0;
    }
    .nav-right-with-contact .mobile-contact-bar .contact-info .contact-item {
      font-size: 2.4em;
    }
    .nav-right-with-contact .side-nav .open .dropdown-menu > li > a {
      padding: 0 25px 0 !important;
    }
  }

  @media (max-width: 480px) {
    .nav-right-with-contact .mobile-dealer-logo .dealer-logo {
      max-width: 230px;
    }
  }

  @media (max-width: 400px) {
    .nav-right-with-contact .mobile-dealer-logo .dealer-logo {
      max-width: 145px;
    }
  }

  .mobile-contact-bar {
    height: 70px;
    background: #fff;
    position: relative;
    left: 0;
    top: 0;
    width: 100%;
  }
  .mobile-contact-bar .mobile-dealer-logo img {
    padding: 10px;
  }
  .mobile-contact-bar .mobile-menu-toggle {
    width: 60px;
    height: 70px;
    padding: 25px 15px;
    float: left;
    background: transparent;
    cursor: pointer;
  }
  .mobile-contact-bar .mobile-menu-toggle .icon-bar {
    display: block;
    margin-top: 4px;
    width: 30px;
    height: 3px;
    border-radius: 1px;
    background-color: var(--primary-color);
  }
  .mobile-contact-bar .mobile-menu-toggle .icon-label {
    display: none;
  }
  .mobile-contact-bar .contact-info {
    float: right;
    margin-top: 1.6em;
    margin-right: 1.2em;
  }
  .mobile-contact-bar .contact-info .contact-item {
    display: inline-block;
    vertical-align: middle;
    color: var(--primary-color);
    font-size: 1.7em;
    letter-spacing: 0.05em;
    margin-right: 0.7em;
  }
  .mobile-contact-bar .contact-info .contact-item:hover {
    text-decoration: none;
    cursor: pointer;
  }
  .mobile-contact-bar .contact-info .contact-item .fa {
    margin-right: 0.1em;
  }
  .mobile-contact-bar .contact-info .contact-item a {
    color: inherit;
  }
  .mobile-contact-bar .contact-info .contact-item a:hover {
    text-decoration: inherit;
  }
  .mobile-nav-bar .side-nav {
    border-bottom: none;
  }
  .mobile-nav-bar .navbar-nav {
    margin-left: 0;
    margin-right: 0;
  }
  .mobile-nav-bar .search-bar {
    border: 1px solid #4d4d4d;
  }
  .mobile-nav-bar .search-bar form {
    margin: 0;
  }
  .mobile-nav-bar .search-bar .input-search {
    margin: 0;
    height: 40px;
  }
  .mobile-nav-bar .search-bar .input-group-btn {
    padding: 0;
  }
  .mobile-nav-bar .search-bar .input-group-btn button {
    height: 40px;
  }
  .mobile-nav-bar .side-nav > li {
    display: block;
    float: left;
    width: 100%;
    border-bottom: 1px solid #333;
  }
  .mobile-nav-bar .side-nav > li > a,
  .mobile-nav-bar .navbar-inner > ul > li.dropdown > a {
    background: #222;
    color: #fff;
    display: block;
    height: 40px;
    font-size: 14px;
    line-height: 20px;
    padding: 10px 15px;
    color: #fff;
    white-space: nowrap;
    font-size: 14px;
    font-weight: normal;
    text-align: left;
    text-transform: none;
    margin: 0;
  }
  .mobile-nav-bar .side-nav > li > a:hover,
  .mobile-nav-bar .navbar-inner > ul > li.dropdown > a:hover {
    background: #1c1c1c;
  }
  .mobile-nav-bar .side-nav > li > ul {
    width: 100%;
    left: 0;
    position: relative;
    list-style: none;
  }
  .mobile-nav-bar .side-nav > li > ul > li > a {
    height: 40px;
    line-height: 40px;
    background: #444;
    font-size: 14px;
    color: #fff;
    text-align: left;
    float: left;
    min-width: 100%;
    position: relative;
    border-bottom: 1px solid #333;
    padding-left: 30px;
  }
  .mobile-nav-bar .side-nav > li > ul > li > a:hover {
    background: #333;
  }
  .mobile-nav-bar .close-mobile-wrap {
    text-align: right;
    padding: 10px 15px;
  }
  .mobile-nav-bar .close-mobile-wrap .close-mobile-nav {
    color: #aaa;
  }
  .mobile-nav-bar .close-mobile-wrap .close-mobile-nav:hover {
    cursor: pointer;
    color: #fff;
  }
  .sidr {
    position: absolute;
    z-index: 20;
    top: 70px;
    height: 100%;
    min-height: 600px;
    width: 260px;
    overflow-x: hidden;
    overflow-y: auto;
    font-size: 15px;
    background: #333;
    color: #fff;
    box-shadow: 0 0 5px 5px #222 inset;
  }
  .sidr .input-search {
    width: 100%;
    font-size: 13px;
    padding: 5px;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0 0 10px;
    border-radius: 2px;
    border: 0;
    background: rgba(0, 0, 0, 0.1);
    color: rgba(255, 255, 255, 0.6);
    clear: both;
  }
  .sidr ul {
    padding: 0;
    border-top: 1px solid #1a1a1a;
    border-bottom: 1px solid #4d4d4d;
    top: 100%;
    float: left;
    min-width: 160px;
    font-size: 14px;
    text-align: left;
    list-style: none;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 4px;
  }
  .sidr ul li {
    margin: 0;
    line-height: 48px;
    border-top: 1px solid #4d4d4d;
    border-bottom: 1px solid #1a1a1a;
  }

  @media (max-width: 767px) {
    .sidr {
      top: 55px;
    }
  }
</style>

<!-- Nav Model Dropdown -->

<style scoped>
  .vehicle-model-dropdown .dropdown-wrapper {
    overflow-y: auto;
  }
  .vehicle-model-dropdown .models-wrapper {
    position: relative;
    padding: 15px 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    justify-content: center;
  }

  .vehicle-model-dropdown .col-sm-12,
  .vehicle-model-dropdown .model-column {
    height: calc(85vh - 85px);
    min-height: 250px;
    max-height: 550px;
  }

  .vehicle-model-dropdown .models-wrapper .model-container {
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 22%;
    -moz-box-flex: 0;
    -moz-flex: 0 0 22%;
    flex: 0 0 22%;
    -ms-flex: 0 0 22%;
    padding: 5px 10px;
    height: 31vh;
    max-width: 320px;
    max-height: 275px;
    min-height: 225px;
  }

  .vehicle-model-dropdown .models-wrapper .model-container .model-text {
    letter-spacing: 0.159em;
    text-align: center;
  }

  .vehicle-model-dropdown .model-text h3 {
    color: black;
    font-weight: 300;
    font-size: 18px;
  }

  .vehicle-model-dropdown .vehicles-count {
    color: grey;
    font-weight: 500;
    font-size: 12px;
  }

  .vehicle-model-dropdown .search-btns {
    padding: 5px;
    background: #f8f8f8;
    border-top: 1px solid #e1e1e1;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    -moz-justify-content: center;
    justify-content: center;
  }

  .vehicle-model-dropdown .search-btns .btn {
    margin-right: 5px;
    background-color: #23395d;
    color: #fff;
  }

  .vehicle-model-dropdown .models-wrapper .model-container img {
    height: 21vh;
    max-height: 200px;
    max-width: 100%;
    width: auto !important;
    margin: 0 auto;
    height: auto;
    display: block;
  }

  /* Custom Nav Styles */

  .nav-right-with-contact .navbar.navbar-inverse,
  .nav-right-with-contact header,
  .nav-right-with-contact,
  .contact-toolbar-dark-component {
    background: #fff;
    box-shadow: none !important;
    border: none !important;
  }

  .nav-right-with-contact,
  .mobile-contact-bar .contact-info .contact-item,
  .mobile-nav-bar .side-nav > li > a,
  .mobile-nav-bar .navbar-inner > ul > li.dropdown.open > a,
  .mobile-nav-bar .side-nav > li > ul.dropdown-menu > li > a,
  .mobile-nav-bar {
    font-size: 13px !important;
  }

  .nav-right-with-contact header {
    padding: 0px 0px 10px;
  }

  .nav-right-with-contact header .container .header-wrapper {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: stretch;
  }

  #header.nav-right-with-contact header .container .header-wrapper #desktop-logo {
    flex-grow: 1;
    max-width: unset !important;
    display: flex;
    margin-top: -20px;
    pointer-events: none;
  }

  .nav-right-with-contact header .container .header-wrapper #desktop-logo > a {
    pointer-events: all;
  }

  .nav-right-with-contact #desktop-header .container .header-wrapper #desktop-logo .dealer-logo {
    margin: 0px;
    margin-top: -10px;
  }

  .nav-right-with-contact header .container .header-wrapper #desktop-menu {
    flex-grow: 0;
  }

  .nav-right-with-contact header .container .header-wrapper #desktop-menu > li > a {
    text-transform: uppercase;
    position: relative;
    outline: none !important;
    font-size: 13px !important;
  }

  .nav-right-with-contact header .container .header-wrapper #desktop-menu > li > a:after {
    display: block;
    content: " ";
    position: absolute;
    left: 0%;
    bottom: 0;
    width: 0;
    transition: all 0.3s ease-in-out;
    height: 2px;
    background-color: transparent;
  }

  .nav-right-with-contact header .container .header-wrapper #desktop-menu > li > a:hover::after {
    width: 100%;
  }

  .nav-right-with-contact .navbar-inverse .navbar-nav > .open > a,
  .nav-right-with-contact .navbar-inverse .navbar-nav > .open > a:hover,
  .nav-right-with-contact .navbar-inverse .navbar-nav > .open > a:focus {
    background-color: transparent;
  }

  .nav-right-with-contact .navbar .dropdown-menu > li > a {
    transition: all 0.3s ease-in-out;
    font-size: 13px !important;
    color: var(--primary-dark);
  }

  .nav-right-with-contact .navbar .dropdown-menu > li > a:hover,
  .nav-right-with-contact .navbar .dropdown-menu > li > a:focus,
  #more-dropdown:hover {
    background-color: var(--primary-color);
    color: #fff;
  }

  .nav-right-with-contact header .container .header-wrapper ul.dropdown-menu,
  #dropdown-search {
    background: #fff;
  }

  .nav-right-with-contact .search-bar .input-search,
  .nav-right-with-contact .search-bar button {
    height: 40px;
    font-size: 13px;
  }

  .nav-right-with-contact #dropdown-search .search-bar {
    border-radius: 3px;
  }

  .nav-right-with-contact .mobile-contact-bar {
    background: #fff !important;
  }

  #header .mobile-contact-bar .mobile-menu-toggle {
    padding-top: 20px;
  }

  .nav-right-with-contact .mobile-contact-bar .mobile-menu-toggle .icon-bar {
    background: var(--primary-color);
    height: 1px;
    margin-top: 7px;
  }

  .nav-right-with-contact .mobile-contact-bar .contact-info .contact-item {
    color: var(--primary-color) !important;
  }

  .mobile-nav-bar .search-bar .input-group-btn button {
    border-radius: 3px !important;
    border-color: #fff;
  }

  #header .mobile-contact-bar .contact-info {
    margin-top: 2em;
  }

  .mobile-nav-bar .side-nav ul,
  .mobile-nav-bar .side-nav li,
  .mobile-nav-bar .side-nav a {
    outline: none !important;
  }

  @media (min-width: 1200px) {
    #header.nav-right-with-contact #dropdown-search .container {
      width: 1170px !important;
    }

    .nav-right-with-contact.nav-right-with-contact
      .navbar.navbar-inverse {
      margin-top: -1px;
    }
  }

  @media (max-width: 767px) {
    #header.nav-right-with-contact .mobile-contact-bar .contact-info {
      margin-top: 1.5em;
    }

    .mobile-contact-bar .contact-info .contact-item {
      margin-right: 1.5em;
    }

    .mobile-contact-bar .contact-info .contact-item .fa {
      font-size: 16px;
    }
    #header .mobile-contact-bar .mobile-menu-toggle {
      padding-top: 12px;
    }
  }

  /* contact toolbar */

  .contact-toolbar-dark-component {
    padding: 38px 0px 0px;
  }

  .contact-toolbar-dark-component a {
    font-weight: 400;
    color: var(--primary-dark) !important;
    font-size: 12px !important;
    opacity: .7;
  }
  .contact-toolbar-dark-component a:hover, 
  .contact-toolbar-dark-component a:hover i.fa {
    opacity: 1;
    text-decoration: none;
  }
  .contact-toolbar-dark-component .container {
    width: 100%;
  }

  .contact-toolbar-dark-component .container > .row {
    display: flex;
    flex-direction: row-reverse;
    padding-right: 12px;
  }

  .contact-toolbar-dark-component .toolbar-social {
    display: none;
  }

  .contact-toolbar-dark-component .toolbar-address {
    flex-grow: 0;
    width: unset;
  }

  .contact-toolbar-dark-component .toolbar-phone-numbers {
    flex-grow: 1;
    padding: 0;
    width: unset;
  }

  .contact-toolbar-dark-component .toolbar-phone-numbers .text-center {
    text-align: right !important;
  }

  .contact-toolbar-dark-component .toolbar-select-language {
    margin-left: 0px;
    padding-left: 10px;
  }

  .contact-toolbar-dark-component .phone-link,
  .contact-toolbar-dark-component .toolbar-address,
  .contact-toolbar-dark-component .toolbar-hours {
    margin-left: 0px;
    padding-left: 10px;
    padding-right: 10px;
    border-right: 1px solid #999999;
  }

  .navbar-inverse .navbar-nav > li > a {
    color: var(--primary-dark);
  }

  @media (min-width: 1501px) {
    .contact-toolbar-dark-component .container {
      width: 85%;
      min-width: 1170px;
    }
  }

  @media (max-width: 1199px) {
    .contact-toolbar-dark-component,
    body > #sticky-wrapper {
      display: none;
    }
  }

  /* Nav Homepage Models */

  li.dropdown.models-dropdown .dropdown-menu.models-dropdown-menu {
    width: fit-content;
    margin: auto;
  }

  .vehicle-model-dropdown {
    display: flex;
    justify-content: center;
  }

  .vehicle-model-dropdown .search-btns {
    align-content: flex-start;
    padding: 30px 15px !important;
    width: 300px;
    min-width: 300px;
    background: #f5f5f5 !important;
    border-top: none !important;
  }

  .vehicle-model-dropdown .dropdown-wrapper {
    background: #fff;
    padding: 20px 0px 30px;
  }

  .vehicle-model-dropdown .dropdown-wrapper .container {
    width: unset !important;
    max-width: unset !important;
  }

  .vehicle-model-dropdown .col-sm-12,
  .vehicle-model-dropdown .model-column {
    height: 100% !important;
    min-height: 100% !important;
    max-height: calc(100vh - 114px) !important;
    overflow: scroll;
  }

  #preview .vehicle-model-dropdown .search-btns .btn, 
  .vehicle-model-dropdown .search-btns .btn {
    display: block;
    width: 100%;
    border-radius: 3px !important;
    margin: 11px auto;
    background: var(--primary-color);
    color: #fff;
    text-transform: uppercase;
    font-size: 15px;
    padding: 10px 15px;
    -moz-transition: all 300ms ease-out;
    -webkit-transition: all 300ms ease-out;
    -o-transition: all 300ms ease-out;
    transition: all 300ms ease-out;
  }

  .vehicle-model-dropdown .search-btns .btn:hover,
  .vehicle-model-dropdown .search-btns .btn:active,
  .vehicle-model-dropdown .search-btns .btn:focus {
    opacity: .75;
  }

  .vehicle-model-dropdown .models-wrapper {
    justify-content: center;
  }

  .vehicle-model-dropdown .models-wrapper .model-container {
    height: 100% !important;
    min-height: unset !important;
    padding: 5px 10px 15px;
  }

  .vehicle-model-dropdown .models-wrapper .model-container a {
    background: #fff !important;
    text-decoration: none !important;
  }

  .vehicle-model-dropdown .models-wrapper .model-container a:hover img {
    transform: scale(1.05);
  }

  .vehicle-model-dropdown .models-wrapper .model-container img {
    max-height: 72px !important;
    max-width: 80% !important;
    transform: perspective(1px) translateZ(0);
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-property: transform;
    transition-property: transform;
  }

  .vehicle-model-dropdown .model-text h3 {
    color: var(--primary-dark) !important;
    font-size: 13px !important;
    font-weight: 400;
    font-family: inherit !important;
    text-transform: uppercase;
    margin-bottom: 0px !important;
  }

  .vehicle-model-dropdown .vehicles-count {
    color: #737373 !important;
  }
  
  .nav-right-with-contact header .container .header-wrapper #desktop-menu > li:nth-last-child(2) > .dropdown-menu,
  .nav-right-with-contact header .container .header-wrapper #desktop-menu > li:nth-last-child(3) > .dropdown-menu {
    left: unset;
    right: 0;
  }
  #header.nav-right-with-contact .container {
    max-width: 100%;
  }
  @media (min-width: 1501px) {
    body #header.nav-right-with-contact .container,
    body .contact-toolbar-dark-component .container {
      width: 1500px;
    }
  }
  @media (max-width: 1500px) {
      #header.nav-right-with-contact .container {
          width: 100% !important;
      }
  }

  #header.nav-right-with-contact header {
    background-color: #fff;
  }
  .nav-right-with-contact .container {
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .nav-right-with-contact header .container .header-wrapper #desktop-menu>li a {
    display: block;
    padding: 10px 12px;
    line-height: 28px;
    text-decoration: none;
    font-weight: 500;
  }
  #header.nav-right-with-contact .mobile-contact-bar {
    height: fit-content;
  }
  li.dropdown.models-dropdown.open .dropdown-menu.models-dropdown-menu {
    position: absolute;
    top: 83%;
    left: 0;
    right: 0;
  }

  li.dropdown.models-dropdown {
      position: static;
  }
  #desktop-header .search-bar button[aria-label="search text"][type="submit"] {
    border-radius: 0px 3px 3px 0px !important;
  }

  #desktop-header .search-bar .input-search {
    border-radius: 3px 0px 0px 3px !important;
  }
  .vehicle-model-dropdown .models-wrapper {
    overflow-y: scroll;
  }
  @media (min-width: 768px) {
    #header.nav-right-with-contact .dealer-logo {
      max-width: 100%;
      display: block;
      margin: 0 auto;
    }
  }
  @media (max-width: 767px) {
    #header.nav-right-with-contact .dealer-logo {
      max-width: 100%;
      padding-bottom: 10px;
      display: block;
      image-rendering: -webkit-optimize-contrast;
    }
  }

  /* Dark Look */

  .nav-right-dark .contact-toolbar-dark-component {
    background: var(--primary-color);
  }
  .nav-right-dark[data-brand="kia"] .navbar-inverse .navbar-nav > li > a {
    letter-spacing: 0 !important;
    font-weight: 700 !important;
    text-transform: capitalize !important;
  }
  .nav-right-dark .contact-toolbar-dark-component a {
    letter-spacing: 0.2em;
    opacity: 1;
  }
  .nav-right-dark .contact-toolbar-dark-component a {
    color: #fff !important;
  }
  .nav-right-dark .contact-toolbar-dark-component a:hover, 
  .nav-right-dark .contact-toolbar-dark-component a:hover i.fa {
    color: #929596 !important;
    opacity: 1;
  }

  /* Kia */
  .nav-right-with-contact[data-brand="kia"] header {
    padding: 0;
  }
  #header.nav-right-with-contact[data-brand="kia"] header .container .header-wrapper #desktop-logo {
    margin-top: 0;
  }
  .nav-right-with-contact[data-brand="kia"] #desktop-header .container .header-wrapper #desktop-logo .dealer-logo {
    margin-top: 0;
    max-height: 60px;
  }
  .nav-right-with-contact[data-brand="kia"] .vehicle-model-dropdown .model-text h3 {
    font-weight: 700;
  }
  .nav-right-with-contact[data-brand="kia"] .vehicle-model-dropdown .vehicles-count {
    font-weight: 300;
  }
  .nav-right-with-contact[data-brand="kia"] header .container .header-wrapper #desktop-menu>li>a:not([href="#dropdown-search"]) {
    font-weight: 700;
  }
  .nav-right-with-contact[data-brand="kia"] .contact-toolbar-dark-component {
    padding: 6.5px 0;
    position: relative;
  }
  .nav-right-with-contact[data-brand="kia"] header .container .header-wrapper #desktop-menu {
    padding: 20px 0;
  }
  .nav-right-with-contact[data-brand="kia"] .contact-toolbar-dark-component, 
  .nav-right-with-contact[data-brand="kia"] .mobile-contact-bar {
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
  .nav-right-with-contact[data-brand="kia"] header .container .header-wrapper #desktop-menu > li > a {
    padding: 10px 15px;
  }
  .nav-right-with-contact[data-brand="kia"] .contact-toolbar-dark-component::after {
    content: '';
    display: block;
    z-index: 1;
    width: 200vw;
    height: 1px;
    position: absolute;
    left: -100vw;
    bottom: 0;
    background-color: #333333;
    background-color: var(--primary-color);
  }
  .nav-right-with-contact[data-brand="kia"] .contact-toolbar-dark-component::after {
    background-color: rgb(255 255 255 / 50%);
  }
  .nav-right-with-contact[data-brand="kia"] header .container .header-wrapper ul.dropdown-menu:not(.models-dropdown-menu) {
    left: unset;
    right: 0;
    top: calc(100% + 10px);
    border-radius: 6px;
  }
  .nav-right-with-contact[data-brand="kia"] .navbar .dropdown-menu>li:first-child>a {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  .nav-right-with-contact[data-brand="kia"] header .container .header-wrapper #desktop-menu>li>a::after {
    left: 15px;
  }
  .nav-right-with-contact[data-brand="kia"] header .container .header-wrapper #desktop-menu>li.open>a::after, 
  .nav-right-with-contact[data-brand="kia"] header .container .header-wrapper #desktop-menu>li>a:hover::after {
    width: calc(100% - 30px);
    background-color: #000000;
    background-color: var(--primary-dark);
  }
  .nav-right-with-contact[data-brand="kia"] header .container .header-wrapper #desktop-menu>li.open>a::after, 
  .nav-right-with-contact[data-brand="kia"] header .container .header-wrapper #desktop-menu>li>a:hover::after {
    background-color: #ffffff;
  }
  .nav-right-with-contact[data-brand="kia"] header .container .header-wrapper #desktop-menu .dropdown-menu > li > a {
    padding: 12px 10px 12px 30px;
    text-align: right;
  }
  .nav-right-with-contact[data-brand="kia"] .navbar-inverse .navbar-nav>.open>a, 
  .nav-right-with-contact[data-brand="kia"] .navbar-inverse .navbar-nav>.open>a:hover, 
  .nav-right-with-contact[data-brand="kia"] .navbar-inverse .navbar-nav>li>a:hover, 
  .nav-right-with-contact[data-brand="kia"] .navbar-inverse .navbar-nav>.open>a:focus, 
  .nav-right-with-contact[data-brand="kia"] .navbar-inverse .navbar-nav>li>a:focus {
    opacity: 1;
  }
  .nav-right-with-contact[data-brand="kia"] .navbar .dropdown-menu>li>a {
    background-color: rgb(255 255 255 / 50%);
    border-bottom: solid 1.5px #000000;
  }
  .nav-right-with-contact[data-brand="kia"] .navbar .dropdown-menu>li:last-child>a {
    border-bottom-color: transparent;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }
  .nav-right-with-contact[data-brand="kia"] .navbar .dropdown-menu>li>a:hover,
  .nav-right-with-contact[data-brand="kia"] .navbar .dropdown-menu>li>a:focus,
  .nav-right-with-contact[data-brand="kia"] #more-dropdown:hover {
    background-color: #000000;
    color: #ffffff;
  }
  .nav-right-with-contact[data-brand="kia"] .contact-toolbar-dark-component .toolbar-phone-numbers a {
    border-right-color: rgb(255 255 255 / 50%);
  }
  .nav-right-with-contact[data-brand="kia"] .contact-toolbar-dark-component .toolbar-address a {
    border-left-color: rgb(255 255 255 / 50%);
  }
  .nav-right-with-contact[data-brand="kia"] .contact-toolbar-dark-component .toolbar-hours a {
    border-left-color: rgb(255 255 255 / 50%);
  }
  .nav-right-with-contact[data-brand="kia"] .mobile-nav-utility-bar {
    border-bottom: solid 1px rgb(255 255 255 / 50%);
  }
  .nav-right-with-contact[data-has-color-fill="false"][data-brand="kia"] header .container .header-wrapper ul.dropdown-menu {
    background-color: #000000;
  }
  .nav-right-with-contact[data-has-color-fill="false"][data-brand="kia"] .navbar .dropdown-menu>li>a {
    color: #ffffff;
  }
  /* INFINITI */
  @media (min-width: 1201px) {
    #header[data-brand="infiniti"].nav-right-with-contact .dealer-logo {
      max-width: 250px;
    }
  }
  @media (min-width: 768px) and (max-width: 1200px) {
    #header[data-brand="infiniti"].nav-right-with-contact .dealer-logo {
      max-width: 300px;
    }
  }
</style>
